import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedSearchOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.0625 26.875C7.41979 26.875 6.01953 26.2961 4.86172 25.1383C3.70391 23.9805 3.125 22.5802 3.125 20.9375C3.125 19.2948 3.70391 17.8945 4.86172 16.7367C6.01953 15.5789 7.41979 15 9.0625 15C10.7052 15 12.1055 15.5789 13.2633 16.7367C14.4211 17.8945 15 19.2948 15 20.9375C15 22.5802 14.4211 23.9805 13.2633 25.1383C12.1055 26.2961 10.7052 26.875 9.0625 26.875ZM25.2125 25.6875L17.6125 18.0875C17.375 17.8302 17.1227 17.568 16.8555 17.3008C16.5883 17.0336 16.326 16.7812 16.0687 16.5437C16.8208 16.0687 17.4245 15.4354 17.8797 14.6438C18.3349 13.8521 18.5625 12.9812 18.5625 12.0312C18.5625 10.5469 18.043 9.28516 17.0039 8.24609C15.9648 7.20703 14.7031 6.6875 13.2188 6.6875C11.7344 6.6875 10.4727 7.20703 9.43359 8.24609C8.39453 9.28516 7.875 10.5469 7.875 12.0312C7.875 12.15 7.87995 12.2638 7.88984 12.3727C7.89974 12.4815 7.91458 12.5953 7.93437 12.7141C7.57812 12.7536 7.18724 12.8328 6.76172 12.9516C6.3362 13.0703 5.95521 13.2089 5.61875 13.3672C5.57917 13.1495 5.54948 12.9318 5.52969 12.7141C5.5099 12.4964 5.5 12.2687 5.5 12.0312C5.5 9.87396 6.24714 8.04818 7.74141 6.55391C9.23568 5.05964 11.0615 4.3125 13.2188 4.3125C15.376 4.3125 17.2018 5.05964 18.6961 6.55391C20.1904 8.04818 20.9375 9.87396 20.9375 12.0312C20.9375 12.8823 20.8039 13.6888 20.5367 14.4508C20.2695 15.2128 19.8984 15.9104 19.4234 16.5437L26.875 24.025L25.2125 25.6875ZM6.95469 23.8766L9.0625 21.7687L11.1406 23.8766L12.0016 23.0453L9.89375 20.9375L12.0016 18.8297L11.1703 17.9984L9.0625 20.1062L6.95469 17.9984L6.12344 18.8297L8.23125 20.9375L6.12344 23.0453L6.95469 23.8766Z",
		fill: "url(#paint0_linear_3947_28117)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_3947_28117",
		x1: 3.00003,
		y1: 27.1719,
		x2: 30.1389,
		y2: 8.6032,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedSearchOff;
